<div class="logged-out">
  <app-home-page [showLeft]="false">
    <emperor-card right [type]="EmperorCardTypes.Outlined">
      <img
        class="logo"
        src="/assets/images/logomark_medium_orange_bkg.svg"
        alt="bold penguin logo"
      />
      <h2 *ngIf="logoutSuccess$ | async; else sessionTimeout" class="subheader">
        You have been successfully logged out
      </h2>
      <ng-template #sessionTimeout>
        <h2 class="subheader">You have been signed out due to inactivity</h2>
      </ng-template>
      <emperor-button
        class="emperor-ui-manually-set-size text-uppercase"
        (click)="gotoUnifiedAuth()"
      >
        Sign in
      </emperor-button>
      <app-footer></app-footer>
    </emperor-card>
  </app-home-page>
</div>
